<template>
    <ion-segment mode="md" scrollable :value="value" @ionChange="segmentChanged($event)" style="margin: 0">
        <ion-segment-button mode="md" value="ShopGlass">
            <ion-label>Produkty</ion-label>
        </ion-segment-button>
        <ion-segment-button mode="md" value="ShopGlassOrders">
            <ion-label>Zamówienia</ion-label>
        </ion-segment-button>
    </ion-segment>
</template>

<script>
    export default {
        name: 'ShopGlassSegment',
        props: ['value'],
        methods: {
            segmentChanged(e) {
                console.log('ShopGlassSegment', e.target.value)
                let routeName = e.target.value;
                this.$router.push({name: routeName}).catch(err => {})
            },
        }
    }
</script>